import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import DisplayMessage from "./DisplayMessage"; // Message Component for the Validation API outputs
import * as assayActions from "../../../actions/assays";
import _ from "underscore";
import { ErrorMessage } from "./ErrorMessage";

// Tooltips for the labels used in the redux-forms
const Tooltip = (tooltip) => (
  <OverlayTrigger
    trigger="hover"
    placement="right"
    overlay={
      <Popover title={tooltip.children.title}>
        {tooltip.children.content}
      </Popover>
    }
  >
    <i className="far fa-question-circle helper-icon" />
  </OverlayTrigger>
);

export const LabelWithTooltip = ({ label, tooltip }) => (
  <div className="tool-tip-label">
    {label && (
      <label className="form-label">
        {label} {tooltip && <Tooltip>{tooltip}</Tooltip>}
      </label>
    )}
  </div>
);

// Text Input Component used in redux-form -> Class Component
export class RenderInput extends React.Component {
  constructor(props) {
    super(props);
  }

  // componentDidMount() {
  //   this.element.current &&
  //     this.element.current.addEventListener("change", this); // add the change listner to the ref
  // }

  render() {
    const {
      input,
      label,
      type,
      placeholder,
      rows,
      className,
      serverValidation, // The validation message from the API endpoint
      tooltip,
      actions,
      changeTargetUUID,

      // input value submitted to the validation API
      meta: { touched, error },
    } = this.props;

    return (
      <React.Fragment>
        <div className="tooltip-input">
          {/* Input label for the Input Field*/}
          {label && (
            <label className="form-label">
              {label} {tooltip && <Tooltip>{tooltip}</Tooltip>}
            </label>
          )}

          <div>
            {/* Input Field for the textArea*/}
            {type === "textArea" && (
              <textarea
                {...input}
                rows={rows}
                placeholder={placeholder}
                className={className}
                type={type}
              />
            )}

            {/*Input Field for the plain text area */}
            {type !== "textArea" && (
              <input
                {...input}
                placeholder={placeholder}
                className={className}
                type={type}
              />
            )}

            {/* Message Display component for the Validation API responses*/}
            <ErrorMessage
              input={input}
              serverValidation={serverValidation}
              error={error}
              actions={actions}
              changeTargetUUID={changeTargetUUID}
            />

            {/*Input Field Validation Messages Display Component*/}
            {touched && error && <DisplayValidationError error={error} />}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

{
  /*Props and Dispatch*/
}
const stateToProps = (state) => ({
  state: state,
});
const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

RenderInput = connect(stateToProps, dispatchToProps)(RenderInput);

// Select Component used in redux-form
export const RenderSelect = ({
  input,
  label,
  className,
  tooltip,
  meta: { touched, error },
  children,
}) => (
  <div>
    <label className="form-label">
      {label} {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </label>
    <div>
      <select className={className} {...input}>
        {children}
      </select>
      {touched && error && <DisplayValidationError error={error} />}
    </div>
  </div>
);

// Radio Button Component used in redux-form
export const RenderRadio = (props) => {
  const {
    meta: { error, touched },
  } = props;
  if (props && props.input && props.options) {
    const renderRadioButtons = (key, index) => {
      return (
        <div key={index} className="form-check form-check-inline">
          <Field
            id={`${props.input.name}`}
            component="input"
            name={props.input.name}
            type="radio"
            value={key}
            className="form-check-input"
          />
          <label className="form-check-label">{props.options[key]}</label>
        </div>
      );
    };
    return (
      <div>
        <label className="form-label">
          {props.label}&nbsp;
          {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
        </label>
        <div>
          {props.options && Object.keys(props.options).map(renderRadioButtons)}
        </div>
        {touched && error && <DisplayValidationError error={error} />}
      </div>
    );
  }
  return <div />;
};

// Validation Error Component - Field Errors
const DisplayValidationError = ({ error }) => {
  return !_.isArray(error) ? (
    <div className="form-error">{error}</div>
  ) : (
    error.map((err, key) => (
      <div key={key} className="form-error">
        {err}
      </div>
    ))
  );
};

// PropTypes Validations for the above components
Tooltip.propTypes = {
  children: PropTypes.object,
};

DisplayValidationError.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

RenderSelect.propTypes = {
  meta: PropTypes.object,
};

LabelWithTooltip.propTypes = RenderRadio.propTypes = {
  tooltip: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  input: PropTypes.object,
};
